/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import "./layout.css"
import NCSUBranding from "./NCSUBranding"
import Sidebar from "./Sidebar"

import NCSULogo from '../images/ncsu.svg';

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <NCSUBranding />
      <div className="mainWrapper">
        <Sidebar />
        <main>{children}</main>
        <footer>
          <div className="logos">
            <a href="https://www.ncsu.edu"><img src={NCSULogo} width="200" alt="NCSU Logo" /></a>
            <span><a href="https://csc.ncsu.edu">Department of Computer Science</a></span>
          </div>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
        children: PropTypes.node.isRequired,
}

export default Layout
